<template>
    <div class="border-t last:border-b border-black">

        <div class="p-4 space-y-10 md:hidden">
            <div class="flex items-">
                <div class="min-w-[100px] text-2xl">
                    <div class="h-2.5 bg-gray-200 rounded-full w-12 mb-4"></div>
                    <div class="h-2.5 bg-gray-200 rounded-full w-6 mb-4"></div>
                </div>

                <div class="text-xl">
                    <div class="h-2.5 bg-gray-200 rounded-full w-32 mb-4"></div>
                </div>
            </div>

            <div class="flex items-top justify-between">
                <div class="flex flex-wrap gap-2 h-fit">
                    <div class="h-2.5 bg-gray-200 rounded-full w-12 mb-4"></div>
                    <div class="h-2.5 bg-gray-200 rounded-full w-12 mb-4"></div>
                    <div class="h-2.5 bg-gray-200 rounded-full w-12 mb-4"></div>
                </div>

                <div class="flex items-center justify-center h-28 bg-gray-200 rounded w-28">
                    <svg class="w-10 h-10 text-gray-100" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                        <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                    </svg>
                </div>
            </div>

            <div>
                <div class="h-2.5 bg-gray-200 rounded-full w-full mb-4"></div>
                <div class="h-2.5 bg-gray-200 rounded-full w-full mb-4"></div>
                <div class="h-2.5 bg-gray-200 rounded-full w-full mb-4"></div>
            </div>
        </div>

        <div class="hidden md:flex transition duration-200 ease-in-out">
            <div class="border-r border-black w-1/3">
                <div class="flex justify-between px-4 lg:px-12 py-6 h-full">
                    <div class="flex items-center justify-center h-full bg-gray-200 rounded w-28">
                        <svg class="w-10 h-10 text-gray-100" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                        </svg>
                    </div>
                    <div class="text-3xl flex flex-col items-end">
                        <div class="h-2.5 bg-gray-200 rounded-full w-12 mb-4"></div>
                        <div class="h-2.5 bg-gray-200 rounded-full w-6 mb-4"></div>
                    </div>
                </div>
            </div>
            <div class="w-2/3">
                <div class="px-4 lg:px-12 py-6">
                    <div class="flex justify-between">
                        <div class="text-2xl w-1/2 pr-12 shrink-0">
                            <div class="h-2.5 bg-gray-200 rounded-full w-32 mb-4"></div>
                        </div>
                        <div class="w-full">
                            <div class="h-2.5 bg-gray-200 rounded-full w-full mb-4"></div>
                            <div class="h-2.5 bg-gray-200 rounded-full w-full mb-4"></div>
                            <div class="h-2.5 bg-gray-200 rounded-full w-full mb-4"></div>
                            <div class="h-2.5 bg-gray-200 rounded-full w-full mb-4"></div>
                            <div class="h-2.5 bg-gray-200 rounded-full w-full mb-4"></div>
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-2 h-fit mt-2">
                        <div class="h-2.5 bg-gray-200 rounded-full w-12 mb-4"></div>
                        <div class="h-2.5 bg-gray-200 rounded-full w-12 mb-4"></div>
                        <div class="h-2.5 bg-gray-200 rounded-full w-12 mb-4"></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

export default {
    name: 'MoleculeCardEventSkeleton',
}
</script>
